var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('video-player',{attrs:{"src":("https://d2vkw31bv9q4du.cloudfront.net/" + _vm.id + ".m3u8"),"type":"application/x-mpegURL","options":_vm.videoOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }